(function () {
  function getEventTarget(event) {
    var target = event.target;

    if (!target || typeof target.closest !== 'function') {
      return null;
    }

    return target;
  }

  function getPreviewImage(card) {
    return card.querySelector('[data-bdl-preview-image]');
  }

  function setActivePreview(wrap, activeButton) {
    wrap.querySelectorAll('[data-bdl-variant-preview]').forEach(function (button) {
      var isActive = button === activeButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function applyPreviewImage(img, src, srcset) {
    if (!img || !src) return;

    img.src = src;
    if (srcset) {
      img.srcset = srcset;
    } else {
      img.removeAttribute('srcset');
    }
    img.classList.remove('lazyload');
    img.classList.add('lazyloaded');
    img.closest('.grid-product')?.classList.add('bdl-variant-preview--showing');
  }

  function resetPreviewImage(card) {
    var img = getPreviewImage(card);
    if (!img || !img.dataset.bdlDefaultSrc) return;

    applyPreviewImage(img, img.dataset.bdlDefaultSrc, img.dataset.bdlDefaultSrcset || '');
    card.classList.remove('bdl-variant-preview--showing');
  }

  function showPreview(button) {
    var wrap = button.closest('[data-bdl-variant-previews]');
    var card = button.closest('.grid-product');
    var img = card ? getPreviewImage(card) : null;
    var src = button.dataset.previewSrc;
    var srcset = button.dataset.previewSrcset;

    if (!wrap || !img || !src) return;

    applyPreviewImage(img, src, srcset);
    setActivePreview(wrap, button);
  }

  function restorePreview(card) {
    if (!card) return;

    var wrap = card.querySelector('[data-bdl-variant-previews]');
    var pinned = wrap && wrap.querySelector('[data-bdl-variant-pinned="true"]');

    if (pinned) {
      showPreview(pinned);
      return;
    }

    resetPreviewImage(card);
    if (wrap) setActivePreview(wrap, null);
  }

  document.addEventListener('mouseenter', function (event) {
    var target = getEventTarget(event);
    if (!target) return;

    var button = target.closest('[data-bdl-variant-preview]');
    if (!button) return;

    showPreview(button);
  }, true);

  document.addEventListener('mouseleave', function (event) {
    var target = getEventTarget(event);
    if (!target) return;

    var previews = target.closest('[data-bdl-variant-previews]');
    if (!previews || previews.contains(event.relatedTarget)) return;

    var card = previews.closest('.grid-product');
    restorePreview(card);
  }, true);

  document.addEventListener('click', function (event) {
    var target = getEventTarget(event);
    if (!target) return;

    var button = target.closest('[data-bdl-variant-preview]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var wrap = button.closest('[data-bdl-variant-previews]');
    if (!wrap) return;

    wrap.querySelectorAll('[data-bdl-variant-preview]').forEach(function (el) {
      el.removeAttribute('data-bdl-variant-pinned');
    });

    button.setAttribute('data-bdl-variant-pinned', 'true');
    showPreview(button);
  });

  function sortCombineRowsByVariantCount() {
    document.querySelectorAll('[data-bdl-combine-sort-variants]').forEach(function (grid) {
      var products = [];
      var viewAll = [];

      Array.prototype.forEach.call(grid.children, function (item) {
        if (!item.classList || !item.classList.contains('grid__item')) return;

        if (
          item.classList.contains('grid__item--view-all') ||
          item.querySelector('.bdl-combine-view-all')
        ) {
          viewAll.push(item);
        } else {
          products.push(item);
        }
      });

      products.sort(function (a, b) {
        var aCount = a.querySelectorAll('[data-bdl-variant-preview]').length;
        var bCount = b.querySelectorAll('[data-bdl-variant-preview]').length;
        return bCount - aCount;
      });

      products.concat(viewAll).forEach(function (item) {
        grid.appendChild(item);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortCombineRowsByVariantCount);
  } else {
    sortCombineRowsByVariantCount();
  }
})();
